export const routes = {
  login: "/login",
  modules: "/modules",
  accessDenied: "/access-denied",
  platform: "/platform",
  platformSchools: "/platform/schools",
  platformUsers: "/platform/users",
  platformCommercial: "/platform/commercial",
  platformSettings: "/platform/settings",
} as const;

export function platformSchoolDetail(slug: string): string {
  return `/platform/schools/${encodeURIComponent(slug)}`;
}
